import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import { Card } from '../../components/Card/Card';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <Card>
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        listing={listing}
      />
    </Card>
  );
};

export default SectionGallery;
